module.exports = __webpack_public_path__ + "static/img/tg.1f521686.png";